import { ExtendBorrowFormComponent } from "../../../components/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowFormComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function ExtendBorrowFormContainer() {
  const titleName = "แบบแจ้งเลื่อนการฝึกอบรมหรือทดสอบมาตรฐานฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ExtendBorrowFormComponent />
      <Footer />
    </div>
  );
}
